import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Video from 'video.js'
import 'video.js/dist/video-js.css'
import "babel-polyfill";
import { Script } from 'vm';
import Blob from './excel/Blob'
import Export2Excel from './excel/Export2Excel.js'
Vue.prototype.$video = Video
// router.beforeEach((to,from,next)=>{
//  if(to.meta.title){
//   document.title = "ѧУ�ռ� - " + to.meta.title
//  }
//  next()
// })

Vue.use(ElementUI, {
  size: 'small'
});
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: function (h) {
    return h(App)
  }
}).$mount('#app')

import axios from 'axios'
axios.defaults.withCredentials = true;

import Router from 'vue-router'
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
return routerPush.call(this, location).catch(error=> error)}